// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3YQuJ","productName":"Table_productName__RPu33"};